<template>
    <v-container>
        <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Pohyby (investovanie)</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="800px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                Novy pohyv
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.account_from"
                                                label="Z uctu"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.account_to"
                                                label="Na ucet"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="editedItem.date" label="Datum"
                                                        prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="editedItem.date" no-title
                                                    @input="dateMenu = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.user_assigned_to"
                                                label="Priradene pouzivatelovi"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.variabilny_symbol"
                                                label="Variabilny symbol"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field v-model="editedItem.amount" label="Suma" type="number"
                                                prefix="€"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2">
                                            <v-text-field v-model="editedItem.currency" label="Mena"></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea v-model="editedItem.details" label="Detaily"></v-textarea>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-checkbox v-model="editedItem.own" label="Vlastne"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Zrusit</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Ulozit</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:item.own="{ item }">
                <v-chip :color="item.own ? 'blue' : 'grey'" dark>{{ item.own ? 'Yes' : 'No' }}</v-chip>
            </template>
            <template v-slot:item.user_assigned_to="{ item }">
                {{ item.user_assigned_to && item.user_assigned_to.id ? item.user_assigned_to.id : item.user_assigned_to
                }}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {
    data: () => ({
        dialog: false,
        dateMenu: false,
        search: '',
        headers: [
            { text: 'ID', value: 'id' },
            { text: 'Datum', value: 'date' },
            { text: 'Suma', value: 'amount' },
            { text: 'Od', value: 'account_from' },
            { text: 'Do', value: 'account_to' },
            { text: 'VS', value: 'variabilny_symbol' },
            { text: 'Pouzivatel', value: 'user_assigned_to' },
            { text: 'Vlastne', value: 'own' },
            { text: 'Akcie', value: 'actions', sortable: false },
        ],
        items: [],
        editedIndex: -1,
        editedItem: {
            account_from: '',
            account_to: '',
            date: new Date().toISOString().substr(0, 10),
            user_assigned_to: null,
            variabilny_symbol: '',
            details: '',
            amount: 0,
            currency: 'EUR',
            own: false,
        },
        defaultItem: {
            account_from: '',
            account_to: '',
            date: new Date().toISOString().substr(0, 10),
            user_assigned_to: null,
            variabilny_symbol: '',
            details: '',
            amount: 0,
            currency: 'EUR',
            own: false,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Transfer' : 'Edit Transfer';
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            apiService.getBankTransfersInvest('', '', 100, 0).then(response => {
                this.items = response.results;
            });
        },

        editItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            if (confirm('Naozaj chcete zmazat?')) {
                apiService.deleteBankTransferInvest(item).then(() => {
                    this.initialize();
                });
            }
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            if (this.editedIndex > -1) {
                apiService.updateBankTransferInvest(this.editedItem).then(() => {
                    this.initialize();
                });
            } else {
                apiService.createBankTransferInvest(this.editedItem).then(() => {
                    this.initialize();
                });
            }
            this.close();
        },
    },
};
</script>